import { format } from 'date-fns'
import { ko } from 'date-fns/locale'

import { type InputValue } from '~/shared/types'

export function fDate(date: InputValue, newFormat?: string) {
  const fm = newFormat || 'yyyy-MM-dd' // 기본 포맷

  return date ? format(new Date(date), fm, { locale: ko }) : ''
}

export function fTime(date: InputValue, newFormat?: string) {
  const fm = newFormat || 'HH:mm' // 기본 포맷을 24시간 형식으로 변경

  return date ? format(new Date(date), fm, { locale: ko }) : ''
}

export function fDateTime(date: InputValue, newFormat?: string) {
  const fm = newFormat || 'yyyy-MM-dd HH:mm' // 날짜와 시간을 한국어로 포맷 (24시간 기준)

  return date ? format(new Date(date), fm, { locale: ko }) : ''
}

export function fDateKo(date: InputValue, newFormat?: string) {
  const fm = newFormat || 'yyyy년 MM월 dd일' // 한국어 날짜 형식으로 변경

  return date ? format(new Date(date), fm, { locale: ko }) : ''
}
